import { WorkflowBox } from '../../WorkflowBox/WorkflowBox';
import { useBranches } from '../../../state/Branches/hooks/useBranches';
import { useMemo } from 'react';
import { PriorityNumber } from '../components/PriorityNumber';
import { useTheme } from 'styled-components';

export const BranchNameWorkflowId = 'BranchNameWorkflow';

export const BranchNameWorkflow = ({ id }) => {
  const { branchSelector } = useBranches();
  const branch = useMemo(() => branchSelector(id), [branchSelector, id]);

  const theme = useTheme();

  return (
    <WorkflowBox
      variant={'Default'}
      id={BranchNameWorkflowId}
      ariaLabel="Branch place holder workflow"
      style={{
        display: 'flex',
        margin: 'auto',
        width: 'auto',
        padding: '8px 16px',
        color: theme.vars.newColor.darkGS2,
        alignItems: 'center',
        gap: theme.designToken.spacing2,
      }}
    >
      <PriorityNumber priority={branch?.priority} />
      {branch?.name}
    </WorkflowBox>
  );
};
